// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import Link from "next/link";

function EnterpriseCtaCmp(Props) {
  var class_name = Props.class_name;
  var href = Props.href;
  var text = Props.text;
  var on_click = Props.on_click;
  return React.createElement(Link, {
              href: href,
              children: React.createElement("div", {
                    className: class_name
                  }, React.createElement("a", {
                        className: class_name,
                        onClick: (function (param) {
                            Curry._1(on_click, undefined);
                          })
                      }, text))
            });
}

var Link$1;

var make = EnterpriseCtaCmp;

export {
  Link$1 as Link,
  make ,
}
/* react Not a pure module */
